import { exportSheetToExcel, exportSheetToPDF, safeFilePart } from './sheetExport';
import { formatISODate } from './dates';

// Same palette as the on-screen TURNO sheet (RemisionFormPage / SalesFormPage.css).
const HEADER_BLUE = '92CDDC';
const MANUAL_GREEN = 'E2F0D9';

// Rows in the exact order of the Formulario de Remisión.
export function remisionSheet(r) {
  const s = r.sale_detail || {};
  return {
    name: 'Remision',
    fileBase: `Remision_${safeFilePart(r.title, 'turno')}_${safeFilePart(s.farm_name, 'hacienda')}_${r.date}`,
    header: r.title,
    headerColor: HEADER_BLUE,
    boldLabels: true,
    rows: [
      { label: 'FECHA', text: formatISODate(r.date), date: r.date },
      { label: 'SEMANA', text: String(r.week), number: r.week },
      { label: 'DIA', text: r.day },
      { label: 'ID DE VENTA', text: String(r.sale), number: r.sale },
      { label: 'EMPRESA', text: s.company_name || '' },
      { label: 'HACIENDA', text: s.farm_name || '' },
      { label: 'EXPORTADORA', text: s.exporter_name || '' },
      { label: 'DESTINO', text: r.destination_name || '' },
      { label: 'TRANSPORTE', text: s.transportation_name || '' },
      { label: 'CONDUCTOR', text: r.driver_name },
      { label: 'CEDULA', text: r.driver_id_number || '' },
      { label: 'CELULAR', text: r.driver_cellphone || '' },
      { label: 'PLACA', text: r.driver_license_plate || '' },
      { label: 'Nº CONTENEDOR', text: r.container_number, fill: MANUAL_GREEN },
      { label: 'Nº TERMÓGRAFO', text: r.thermograph_number, fill: MANUAL_GREEN },
      { label: 'SELLO NAVIERA', text: r.shipping_line_seal, fill: MANUAL_GREEN },
      { label: 'SELLO SATELITAL', text: r.satellite_seal, fill: MANUAL_GREEN },
      { label: 'COD MAGAP', text: s.magap || '' },
      { label: 'MARCA CAJA', text: s.brand_name || '' },
      { label: 'COD HACIENDA', text: r.farm_code || '', fill: MANUAL_GREEN },
      { label: 'Nº CAJAS', text: String(r.boxes ?? ''), number: r.boxes, fill: MANUAL_GREEN },
      { label: 'PALLETS', text: String(r.pallets ?? ''), number: r.pallets, fill: MANUAL_GREEN },
      {
        label: 'PESO FRUTA CON CARTÓN',
        text: r.fruit_weight_with_carton != null ? String(Number(r.fruit_weight_with_carton)).replace('.', ',') : '',
        number: r.fruit_weight_with_carton != null ? Number(r.fruit_weight_with_carton) : undefined,
        decimal: true,
        fill: MANUAL_GREEN,
      },
      {
        label: 'PESO CAJA FRUTA', text: s.fruit_weight ? String(Number(s.fruit_weight)).replace('.', ',') : '',
        number: s.fruit_weight ? Number(s.fruit_weight) : undefined, decimal: true,
      },
      { label: 'TIPO DE CAJA', text: s.box_type_name || '' },
      { label: 'NOMBRE INSPECTOR', text: r.inspector_name },
    ],
  };
}

export function exportRemisionToExcel(remision) {
  return exportSheetToExcel(remisionSheet(remision));
}

export function exportRemisionToPDF(remision) {
  exportSheetToPDF(remisionSheet(remision));
}
